import BaseModel from '@/model/BaseModel';

export default class ModelGraficoLinha extends BaseModel {
  constructor(series = [], names = [], colors = [], categories = []) {
    super();

    this.series = series;
    this.names = names;
    this.colors = colors;
    this.categories = categories;
  }

  fromModelToApexChart() {
    const series = this.names.map((name, index) => ({
      name,
      data: this.series[index],
    }));

    return {
      series,
      colors: this.colors,
      xaxis: {
        categories: this.categories,
      },
    };
  }
}
